import { DoctorSearchItem } from "./DoctorSearchItem/DoctorSearchItem";

export default {
  DoctorSearchItem,
};
